import { useLanguage } from "context/LanguageContext";
import "./pagenotfound.scss";


const PageNotFound = () => {
    const { t } = useLanguage();

    return (
        <div className="main">
            <div className="header">
                <div className="notFound">
                    <h1>{t("page.notFound")}</h1>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;